import { render, staticRenderFns } from "./collapseItem.vue?vue&type=template&id=670f1b8c&scoped=true&"
import script from "./collapseItem.vue?vue&type=script&lang=js&"
export * from "./collapseItem.vue?vue&type=script&lang=js&"
import style0 from "./collapseItem.vue?vue&type=style&index=0&id=670f1b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f1b8c",
  null
  
)

component.options.__file = "collapseItem.vue"
export default component.exports